module.exports = __webpack_public_path__ + "static/media/bpcl.59ca15ae.png";